function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { View, StyleSheet } from 'react-native';
import { withTheme } from '../../core/theming';
import Text, { TextType } from '../Typography/Text';
export let BadgeType;

(function (BadgeType) {
  BadgeType["Default"] = "default";
  BadgeType["Critical"] = "critical";
  BadgeType["Important"] = "important";
  BadgeType["Improvements"] = "improvements";
})(BadgeType || (BadgeType = {}));

const Badge = _ref => {
  let {
    style,
    value,
    type = BadgeType.Default,
    isBold = false,
    theme: {
      colors
    },
    accessibility,
    ...props
  } = _ref;

  const getColor = () => {
    switch (type) {
      case BadgeType.Critical:
        return colors.notification.critical;

      case BadgeType.Important:
        return colors.notification.important;

      case BadgeType.Improvements:
        return colors.notification.improvement;

      default:
        return colors.background.default;
    }
  };

  return /*#__PURE__*/React.createElement(View, _extends({}, props, {
    style: [styles.container, {
      backgroundColor: getColor()
    }, style]
  }), /*#__PURE__*/React.createElement(Text, _extends({}, accessibility, {
    allowFontScaling: false,
    style: styles.text,
    type: isBold ? TextType.Caption3Bold : TextType.Caption3,
    color: type === BadgeType.Default ? colors.text.light : colors.text.ondark
  }), value));
};

const styles = StyleSheet.create({
  container: {
    height: 16,
    minWidth: 16,
    borderRadius: 8,
    paddingHorizontal: 5,
    textAlign: 'center'
  },
  text: {
    textAlign: 'center'
  }
});
export default withTheme(Badge);
//# sourceMappingURL=index.js.map